import { initLiveList } from '../../shared/liveList.js';

// The Salesforce link rows that will not go through (WOR-LI-J03).
//
// Nothing but the live list, the same as the status page beside it: what to do
// about a discrepancy is a CLI decision, so there is no action to wire up here.
//
// Goes when Salesforce is retired, along with the rest of the module.

export function initSalesforceAbweichungen() {
  initLiveList({
    results: 'salesforce-abweichung-results',
    path: '/salesforce/abweichungen',
    forms: ['salesforce-abweichung-filter']
  });
}
